import * as z from 'zod';
import { localizedTextSchema } from './localized';

export const lookupOptionSchema = z
  .object({
    id: z.string(),
    name: localizedTextSchema.nullish(),
  })
  .loose();
export type LookupOption = z.infer<typeof lookupOptionSchema>;
